import React, { useEffect, useRef } from "react";
import "./AnnouncementPostTabs.scss";
import { CommonEnums } from "../../../../enums/common.enums";

const AnnouncementPostTabs = ({
  activeTab,
  onTabChange,
}: {
  activeTab: string;
  onTabChange: (tab: string) => void;
}) => {
  const tabs = [
    {
      slug: CommonEnums.announcementPostTabs.post_type.key,
      label: CommonEnums.announcementPostTabs.post_type.value,
    },
    {
      slug: CommonEnums.announcementPostTabs.announcement_type.key,
      label: CommonEnums.announcementPostTabs.announcement_type.value,
    },
    {
      slug: CommonEnums.announcementPostTabs.select_template.key,
      label: CommonEnums.announcementPostTabs.select_template.value,
    },
    {
      slug: CommonEnums.announcementPostTabs.create_post.key,
      label: CommonEnums.announcementPostTabs.create_post.value,
    },
    {
      slug: CommonEnums.announcementPostTabs.configure_post.key,
      label: CommonEnums.announcementPostTabs.configure_post.value,
    },
  ];

  const activeIndex = tabs.findIndex((tab) => tab.slug === activeTab);
  const tabRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    if (tabRefs.current[activeIndex]) {
      tabRefs.current[activeIndex]?.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  return (
    <div className="tabs-scroll-container">
      <div className="tabs">
        {tabs.map((tab, index) => {
          const isActive = activeTab === tab.slug;
          const isCompleted = index < activeIndex;
          const isDisabled = index !== activeIndex;

          return (
            <div
              ref={(el) => (tabRefs.current[index] = el)}
              key={tab.slug}
              className={`tab ${isActive ? "active" : ""} ${
                isCompleted ? "completed" : ""
              } ${isDisabled ? "disabled" : ""}`}
              onClick={() => onTabChange(tab.slug)}
            >
              {tab.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AnnouncementPostTabs;
